"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tableSearchHeight = exports.resizerWidth = exports.HUNDRED_DECIMAL = exports.columnMinWidth = exports.columnMinWidthPixels = exports.mouseupEvent = exports.mousemoveEvent = exports.mousedownEvent = exports.sortingType = exports.resizeEvent = exports.selectPageSize = exports.searchBarSize = exports.paginationRootId = exports.mouseDownEvent = exports.noneStyle = exports.tabIndex = exports.actionColumnText = exports.paginationArialLabel = exports.navigationRole = exports.tableAriaLabel = exports.tableRole = exports.paginationOptionsPrefix = exports.sortIconSuffix = exports.tableHeaderPrefix = exports.actionItemPrefix = exports.tableCellPrefix = exports.tableRowPrefix = exports.defaultIconSize = exports.paginationIconSize = exports.classes = void 0;
var classes = {
  container: 'bds-table-container',
  cell: 'bds-table-cell',
  render: 'bds-table-cell-render',
  expandedCellRender: 'bds-table-expanded-row-cell-render',
  cellRender: 'bds-table-cell-custom',
  row: 'bds-table-row',
  expandedRow: 'bds-table-expanded-row',
  noDataFound: 'bds-table-expanded-row-no-data-found',
  expandRow: 'bds-table-expand-row',
  expandRowIcons: 'bds-table-expand-row-icons',
  rowHighlighted: 'bds-table-row-highlighted',
  rowSelectable: 'bds-table-row-selectable',
  resizer: 'bds-table-resizer',
  resizerHover: 'bds-table-resizer-hover',
  header: 'bds-table-header-row',
  headerCell: 'bds-table-header-cell',
  headerCellNoBackground: 'bds-table-header-cell-no-background',
  headerCellContainer: 'bds-table-header-cell-container',
  headerText: 'bds-table-header-text',
  headerIcon: 'bds-table-header-icon',
  headerTextIconContainer: 'bds-table-header-text-icon',
  search: 'bds-table-search',
  searchContainer: 'bds-table-search-container',
  sortIconResizeContainer: 'bds-table-sort-icon-resize-container',
  table: 'bds-table',
  infiniteScrollInsideModal: 'table-infinite-scroll-inside-modal',
  headerCursor: 'bds-table-header-text-cursor',
  addNewRow: 'bds-add-new-row',
  emptyNewRowHeader: 'bds-empty-new-row-header',
  columnFilter: 'bds-table-column-filter'
};
exports.classes = classes;
var paginationIconSize = 16;
exports.paginationIconSize = paginationIconSize;
var defaultIconSize = 24;
exports.defaultIconSize = defaultIconSize;
var tableRowPrefix = 'table-row';
exports.tableRowPrefix = tableRowPrefix;
var tableCellPrefix = 'table-cell';
exports.tableCellPrefix = tableCellPrefix;
var actionItemPrefix = 'action-item';
exports.actionItemPrefix = actionItemPrefix;
var tableHeaderPrefix = 'table-header';
exports.tableHeaderPrefix = tableHeaderPrefix;
var sortIconSuffix = 'sort-icon';
exports.sortIconSuffix = sortIconSuffix;
var paginationOptionsPrefix = 'pagination-option';
exports.paginationOptionsPrefix = paginationOptionsPrefix;
var tableRole = 'grid';
exports.tableRole = tableRole;
var tableAriaLabel = 'caption';
exports.tableAriaLabel = tableAriaLabel;
var navigationRole = 'navigation';
exports.navigationRole = navigationRole;
var paginationArialLabel = 'table-pagination-navigation';
exports.paginationArialLabel = paginationArialLabel;
var actionColumnText = 'Action';
exports.actionColumnText = actionColumnText;
var tabIndex = '0';
exports.tabIndex = tabIndex;
var noneStyle = 'none';
exports.noneStyle = noneStyle;
var mouseDownEvent = 'mousedown';
exports.mouseDownEvent = mouseDownEvent;
var paginationRootId = 'bds-pagination-root';
exports.paginationRootId = paginationRootId;
var searchBarSize = '400px';
exports.searchBarSize = searchBarSize;
var selectPageSize = 'Table Page Size options';
exports.selectPageSize = selectPageSize;
var resizeEvent = 'resize';
exports.resizeEvent = resizeEvent;
var sortingType = {
  unsorted: 'unsorted',
  ascending: 'ascending',
  descending: 'descending'
};
exports.sortingType = sortingType;
var mousedownEvent = 'mousedown';
exports.mousedownEvent = mousedownEvent;
var mousemoveEvent = 'mousemove';
exports.mousemoveEvent = mousemoveEvent;
var mouseupEvent = 'mouseup';
exports.mouseupEvent = mouseupEvent;
var columnMinWidthPixels = '88px';
exports.columnMinWidthPixels = columnMinWidthPixels;
var columnMinWidth = 88;
exports.columnMinWidth = columnMinWidth;
var HUNDRED_DECIMAL = 100.0;
exports.HUNDRED_DECIMAL = HUNDRED_DECIMAL;
var resizerWidth = 4;
exports.resizerWidth = resizerWidth;
var tableSearchHeight = '3.53rem';
exports.tableSearchHeight = tableSearchHeight;